<template>
  <b-form @submit.prevent="save">
    <b-form-group label="Name:">
      <b-form-input
        type="text"
        v-model.trim="$v.displayName.$model"
        :class="{ 'is-invalid': $v.displayName.$error }"
        autocomplete="off"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.displayName.required">Display Name is required</b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.displayName.isUnique"
      >Column with the same name already exists</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Start title:">
      <b-form-input
        type="text"
        v-model.trim="$v.startTitle.$model"
        :class="{ 'is-invalid': $v.startTitle.$error }"
        autocomplete="off"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.startTitle.required">Display Name is required</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Workflow:">
      <b-form-select
        v-model="$v.workflow.$model"
        :class="{ 'is-invalid': $v.workflow.$error }"
        :options="availableWorkflows"
        :disabled="inPorcess"
      />
      <b-form-invalid-feedback v-if="!$v.workflow.required">Table to lookup is required</b-form-invalid-feedback>
    </b-form-group>
    <b-button variant="success" type="submit">Save</b-button>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'type',
    'gridId',
    'rowIndex',
    'sectionIndex'
  ],
  data() {
    return {
      inPorcess: false,
      displayName: null,
      workflow: null,
      startTitle: null
    }
  },
  computed: {
    ...mapState(['dataGrid_options', 'workflows']),
    availableWorkflows() {
      const workflows = []

      for (let item in this.workflows) {
        workflows.push({
          text: this.workflows[item].name,
          value: item,
        })
      }

      return workflows
    },
  },
  methods: {
    async save() {
      if (this.inPorcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inPorcess = true

      const data = {
        type: this.type,
        gridId: this.gridId,
        displayName: this.displayName,
        propertyName: this.$sanitize(this.displayName),
        workflow: this.workflow,
        startTitle: this.startTitle
      }

      await db.dataGrid.data.addColumn(data)

      this.$store.commit('dataGrid_setLogsValue', {
        type: 'ColChange',
        newVal: data.displayName,
        gridId: data.gridId,
      })

      this.inPorcess = false
      this.displayName = null
      this.startTitle = null
      this.workflow = null
      this.$nextTick(() => {
        this.$v.$reset()
      })

      this.$emit('submitted')
    }
  },
  validations: {
    displayName: {
      required,
      isUnique(value) {
        if (!value) return true

        for (let cellKey in this.dataGrid_options[this.gridId].meta) {
          if (this.$sanitize(value) === cellKey) return false
        }

        return true
      },
    },
    startTitle: {
      required
    },
    workflow: {
      required,
    },
  },
}
</script>
